export default "__VITE_ASSET__DuCAwg5Z__"